"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthError = void 0;
var AuthError;
(function (AuthError) {
    AuthError["InvalidUserOrPassword"] = "Invalid user or password";
    AuthError["EmailInUse"] = "Email already in use";
})(AuthError = exports.AuthError || (exports.AuthError = {}));
//# sourceMappingURL=LoginResponses.js.map